// Copyright (c) 2026 PGNS LLC

import { cn } from '@/lib/utils';
import type { ComponentStatus } from '@/lib/api';
import { STATUS_FILL, STATUS_LABEL } from '@/lib/status';

/**
 * A status marker that is never colour-only: the label ships alongside every
 * dot, so the page stays readable for a reader who cannot separate the green
 * from the red.
 */
export function StatusDot({
  status,
  className,
  showLabel = true,
}: {
  status: ComponentStatus;
  className?: string;
  showLabel?: boolean;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        aria-hidden="true"
        className={cn('size-2.5 rounded-full shrink-0', STATUS_FILL[status])}
      />
      <span className={cn('text-sm', showLabel ? '' : 'sr-only')}>{STATUS_LABEL[status]}</span>
    </span>
  );
}
